<div class="shop-info-header">
    <h-shop-info-title
        class="shop-name"
        [id]="'shop-name-' + shop.shopId"
        [headerLevelShopTitle]="headerLevelShopTitle"
        [isScreenReaderOnly]="false"
        data-testid="shop-info-title">
        <span [id]="'title-' + shop.shopId" class="paragraph-medium bold">{{ shop.shortTitle }}</span>
    </h-shop-info-title>

    @if (linkMode !== "none" && shop.url) {
        <a
            class="redirect-page-container"
            [attr.aria-describedby]="'title-' + shop.shopId"
            [attr.target]="linkMode === 'external' ? '_blank' : undefined"
            [attr.rel]="linkMode === 'external' ? 'noopener noreferrer' : undefined"
            [href]="shop.url"
            (click)="navigateOnShopPage($event)">
            <h-svg-icon [name]="'open-external'"></h-svg-icon>
            <p class="sr-only"
                ><span i18n="@@hermes-global-translations.store-page">Store page</span
                ><span i18n="@@hermes.footer.social.new-window"> (new window) </span>
            </p>
        </a>
    }
</div>
